module.exports = __webpack_public_path__ + "static/copic_reverse-db9e7ab0a45e7432f8c73ba579efcc52.svg";